// Ohio University's undergraduate majors (#2652). Read on 2026-10-01 from
// the official 2026-2027 Undergraduate Catalog (catalogs.ohio.edu,
// catoid=107): each college's page lists its programs by department, and
// every bachelor's major there is kept, grouped by that college. Left out:
// associate degrees, the regional-campus copy of Communication Studies,
// undecided and exploratory programs, meta-majors, pre-majors, accelerated
// graduate pathways, minors and certificates. Majors offered through the
// Honors Tutorial College are listed under it, as the catalog does. Names
// are the catalog's with the word "Major" dropped; the catalog's dashes
// between a major and its concentration are written as " - " and its curly
// apostrophes as straight ones. Degree abbreviations are the catalog's. The
// KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "ohio-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Ohio University's official 2026-2027 Undergraduate Catalog, grouped by the college that offers it, with the degree it leads to. Associate degrees, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "Ohio University 2026-2027 Undergraduate Catalog, College of Arts and Sciences",
                "url": "https://catalogs.ohio.edu/content.php?catoid=107&navoid=12071"
            },
            "majors": [
                {
                    "name": "Environmental Science and Sustainability",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Sciences - Biological Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Sciences - Cellular and Molecular Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Sciences - Environmental Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biological Sciences - Human Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biological Sciences - Marine, Freshwater, and Environmental Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Sciences - Prephysical Therapy",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Sciences - Preprofessional Program",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Sciences - Wildlife and Conservation Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Microbiology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry - Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry - Environmental",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry - Predentistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry - Premedicine",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry - Prepharmacy",
                    "degree": "B.S."
                },
                {
                    "name": "Forensic Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Classical Civilization",
                    "degree": "B.A."
                },
                {
                    "name": "Classical Languages",
                    "degree": "B.A."
                },
                {
                    "name": "Classics and Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Geological Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Geological Sciences - Environmental Geoscience",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "English - Creative Writing",
                    "degree": "B.A."
                },
                {
                    "name": "English - Literature, Culture, & Writing",
                    "degree": "B.A."
                },
                {
                    "name": "English - Pre-Law",
                    "degree": "B.A."
                },
                {
                    "name": "Applied Plant Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental and Plant Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Field Ecology",
                    "degree": "B.A."
                },
                {
                    "name": "Geography - Meteorology",
                    "degree": "B.S."
                },
                {
                    "name": "Geography - Climate, Environment and Society",
                    "degree": "B.S."
                },
                {
                    "name": "Geography - Environmental Pre-Law",
                    "degree": "B.S."
                },
                {
                    "name": "Geography - Geographic Information Science",
                    "degree": "B.S."
                },
                {
                    "name": "Geography - Geography",
                    "degree": "B.S."
                },
                {
                    "name": "Geography - Globalization and Development",
                    "degree": "B.S."
                },
                {
                    "name": "Geography - Urban Planning and Sustainability",
                    "degree": "B.S."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "History - Pre-Law",
                    "degree": "B.A."
                },
                {
                    "name": "International Studies",
                    "degree": "B.A."
                },
                {
                    "name": "International Studies - War and Peace",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics - Actuarial Science",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics - Applied",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics - Mathematical Statistics",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy - Pre-Law",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy - Pre-Theology",
                    "degree": "B.A."
                },
                {
                    "name": "Physics Astrophysics",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Physics - Applied Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science - Pre-Law",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Psychology Prephysical Therapy",
                    "degree": "B.S."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology - Criminology",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology - Pre-Law",
                    "degree": "B.A."
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Business",
            "source": {
                "label": "Ohio University 2026-2027 Undergraduate Catalog, College of Business",
                "url": "https://catalogs.ohio.edu/content.php?catoid=107&navoid=12072"
            },
            "majors": [
                {
                    "name": "Business Economics",
                    "degree": "B.B.A."
                },
                {
                    "name": "General Business",
                    "degree": "B.B.A."
                },
                {
                    "name": "Accounting",
                    "degree": "B.B.A."
                },
                {
                    "name": "Business Analytics",
                    "degree": "B.B.A."
                },
                {
                    "name": "Management Information Systems",
                    "degree": "B.B.A."
                },
                {
                    "name": "Finance",
                    "degree": "B.B.A."
                },
                {
                    "name": "Business Pre-Law",
                    "degree": "B.B.A."
                },
                {
                    "name": "Business Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "B.B.A."
                },
                {
                    "name": "International Business",
                    "degree": "B.B.A."
                },
                {
                    "name": "Strategic Leadership and Management",
                    "degree": "B.B.A."
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "B.B.A."
                },
                {
                    "name": "Marketing",
                    "degree": "B.B.A."
                },
                {
                    "name": "Sport Management",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Scripps College of Communication",
            "source": {
                "label": "Ohio University 2026-2027 Undergraduate Catalog, Scripps College of Communication",
                "url": "https://catalogs.ohio.edu/content.php?catoid=107&navoid=12073"
            },
            "majors": [
                {
                    "name": "Communication",
                    "degree": "B.S."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Cybersecurity Operations",
                    "degree": "B.S."
                },
                {
                    "name": "Information & Telecommunication Systems, Cybersecurity Track",
                    "degree": "B.S."
                },
                {
                    "name": "Information & Telecommunication Systems, ECT (VR/AR) Track",
                    "degree": "B.S."
                },
                {
                    "name": "Information and Telecommunication Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Virtual Reality and Game Development",
                    "degree": "B.S."
                },
                {
                    "name": "Journalism Carr Van Anda",
                    "degree": "B.S."
                },
                {
                    "name": "Journalism News and Information",
                    "degree": "B.S."
                },
                {
                    "name": "Journalism Strategic Communication",
                    "degree": "B.S."
                },
                {
                    "name": "Media Arts and Studies - Animation",
                    "degree": "B.S."
                },
                {
                    "name": "Media Arts and Studies - Media and Social Change",
                    "degree": "B.S."
                },
                {
                    "name": "Media Arts and Studies - Media Arts Production",
                    "degree": "B.S."
                },
                {
                    "name": "Media Arts and Studies - Music Production and Recording Industry",
                    "degree": "B.S."
                },
                {
                    "name": "Visual Communication - Commercial Photography",
                    "degree": "B.S."
                },
                {
                    "name": "Visual Communication - Information Graphics/Publication Design",
                    "degree": "B.S."
                },
                {
                    "name": "Visual Communication - Multimedia",
                    "degree": "B.S."
                },
                {
                    "name": "Visual Communication - Photojournalism",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Patton College of Education",
            "source": {
                "label": "Ohio University 2026-2027 Undergraduate Catalog, Patton College of Education",
                "url": "https://catalogs.ohio.edu/content.php?catoid=107&navoid=12074"
            },
            "majors": [
                {
                    "name": "Human Services",
                    "degree": "B.A.S."
                },
                {
                    "name": "Customer Service Leadership",
                    "degree": "B.A.S."
                },
                {
                    "name": "Health and Physical Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Outdoor Recreation and Education",
                    "degree": "B.S."
                },
                {
                    "name": "Physical Activity and Sport Coaching",
                    "degree": "B.S."
                },
                {
                    "name": "Recreation Management",
                    "degree": "B.S."
                },
                {
                    "name": "Restaurant, Hotel, and Tourism",
                    "degree": "B.S."
                },
                {
                    "name": "Retail and Fashion Merchandising",
                    "degree": "B.S."
                },
                {
                    "name": "Early Childhood and Elementary Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Earth/Space Science",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Integrated Language Arts",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Integrated Language Arts - Spanish Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Integrated Mathematics",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Integrated Science",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Integrated Social Studies",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Intervention Specialist Dual License",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Life Science",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Middle Childhood Language Arts and Mathematics",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Middle Childhood Language Arts and Science",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Middle Childhood Language Arts and Social Studies",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Middle Childhood Mathematics and Science",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Middle Childhood Mathematics and Social Studies",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Middle Childhood Science and Social Studies",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Physical Science - Chemistry",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Physical Science - Physics and Chemistry",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Physical Science - Physics",
                    "degree": "B.S.Ed."
                }
            ]
        },
        {
            "name": "Russ College of Engineering and Technology",
            "source": {
                "label": "Ohio University 2026-2027 Undergraduate Catalog, Russ College of Engineering and Technology",
                "url": "https://catalogs.ohio.edu/content.php?catoid=107&navoid=12075"
            },
            "majors": [
                {
                    "name": "Aviation Flight",
                    "degree": "B.S."
                },
                {
                    "name": "Aviation Management",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Artificial Intelligence",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Cybersecurity Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering with Computer Engineering Track",
                    "degree": "B.S."
                },
                {
                    "name": "Engineering Technology and Management",
                    "degree": "B.S."
                },
                {
                    "name": "Project Management",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Energy Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Chaddock + Morrow College of Fine Arts",
            "source": {
                "label": "Ohio University 2026-2027 Undergraduate Catalog, Chaddock + Morrow College of Fine Arts",
                "url": "https://catalogs.ohio.edu/content.php?catoid=107&navoid=12076"
            },
            "majors": [
                {
                    "name": "Art - Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Art - Studio Art",
                    "degree": "B.A."
                },
                {
                    "name": "Graphic Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Interior Architecture",
                    "degree": "B.F.A."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Studio Art - Art Therapy",
                    "degree": "B.F.A."
                },
                {
                    "name": "Dance - Performance and Choreography",
                    "degree": "B.F.A."
                },
                {
                    "name": "Film",
                    "degree": "B.F.A."
                },
                {
                    "name": "Music Education: Choral Emphasis",
                    "degree": "B.Mus."
                },
                {
                    "name": "Music Education: Instrumental Emphasis",
                    "degree": "B.Mus."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music - Composition",
                    "degree": "B.Mus."
                },
                {
                    "name": "Music - Instrumental Performance",
                    "degree": "B.Mus."
                },
                {
                    "name": "Music - Organ Performance",
                    "degree": "B.Mus."
                },
                {
                    "name": "Music - Piano Pedagogy",
                    "degree": "B.Mus."
                },
                {
                    "name": "Music - Piano Performance",
                    "degree": "B.Mus."
                },
                {
                    "name": "Music - Popular Music Performance",
                    "degree": "B.Mus."
                },
                {
                    "name": "Music - Voice Performance",
                    "degree": "B.Mus."
                },
                {
                    "name": "Theater",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theater Performance - Acting or Musical Theater Tracks",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theater - Playwriting",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theater - Production Design and Technology",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theater - Stage Management",
                    "degree": "B.F.A."
                }
            ]
        },
        {
            "name": "College of Health Sciences and Professions",
            "source": {
                "label": "Ohio University 2026-2027 Undergraduate Catalog, College of Health Sciences and Professions",
                "url": "https://catalogs.ohio.edu/content.php?catoid=107&navoid=12077"
            },
            "majors": [
                {
                    "name": "Exercise Physiology",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition Science - Pre-Medicine",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition Science - Pre-Physician Assistant",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition - Culinary",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition - Dietetics",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition - Environmental",
                    "degree": "B.S."
                },
                {
                    "name": "Hearing, Speech and Language Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Baccalaureate Nursing",
                    "degree": "B.S.N."
                },
                {
                    "name": "Integrated Healthcare Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                },
                {
                    "name": "Community and Public Health",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Health Science",
                    "degree": "B.S."
                },
                {
                    "name": "Health Services Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Human Development and Family Science",
                    "degree": "B.S."
                },
                {
                    "name": "Social Work",
                    "degree": "B.A."
                },
                {
                    "name": "Social Work",
                    "degree": "B.S.W."
                }
            ]
        },
        {
            "name": "Honors Tutorial College",
            "source": {
                "label": "Ohio University 2026-2027 Undergraduate Catalog, Honors Tutorial College",
                "url": "https://catalogs.ohio.edu/content.php?catoid=107&navoid=12078"
            },
            "majors": [
                {
                    "name": "Advanced Computing",
                    "degree": "B.S."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Astrophysics",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Classics",
                    "degree": "B.A."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Dance Tutorial",
                    "degree": "B.F.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Engineering Physics",
                    "degree": "B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental and Plant Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Film Tutorial",
                    "degree": "B.F.A."
                },
                {
                    "name": "General Theater",
                    "degree": "B.F.A."
                },
                {
                    "name": "Geography",
                    "degree": "B.S."
                },
                {
                    "name": "Geological Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Hearing, Speech and Language Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Journalism",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Media Arts and Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Social Work",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Translational Health - Applied Health",
                    "degree": "B.S."
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "University College",
            "source": {
                "label": "Ohio University 2026-2027 Undergraduate Catalog, University College",
                "url": "https://catalogs.ohio.edu/content.php?catoid=107&navoid=12079"
            },
            "majors": [
                {
                    "name": "Criminal Justice",
                    "degree": "B.S."
                },
                {
                    "name": "Data Analytics",
                    "degree": "B.S."
                },
                {
                    "name": "General Studies",
                    "degree": "B.G.S."
                },
                {
                    "name": "Integrative Studies",
                    "degree": "B.I.S."
                },
                {
                    "name": "Organizational Studies",
                    "degree": "B.T.A.S."
                }
            ]
        }
    ]
};

export default majors;
